import * as types from '../mutation-types';
import api from '@/store/utils/api';

const state = {
    currentClient: {},
};

const getters = {
    currentClient: state => state.currentClient,
};

const actions = {
    getClient({ commit, rootGetters }, payload) {
        return api.get(`/client-widgets/${payload.clientId}/`).then(res => {
            commit(types.UPDATE_CURRENT_CLIENT, res);
            return res;
        });
    },
};

const mutations = {
    [types.UPDATE_CURRENT_CLIENT](state, payload) {
        state.currentClient = payload;
    },
};

export default {
    namespaced: true,
    getters,
    state,
    actions,
    mutations,
};
